import {ComponentModalConfig, ModalSize} from "ng2-semantic-ui";
import {DxModalOptions} from "./ui-options/dx-modal-options";
import {DxModalResult} from "./dx-modal-result";
import {Type} from "@angular/core";
import {DxModalContext} from "./dx-modal-context";


export class DxModalConfig extends ComponentModalConfig<DxModalContext, DxModalResult, DxModalResult> {
  /**
   * Создает инстанс кофига модального окна.
   * @constructor
   * @param {Type<any>} component - класс копонента модального окна.
   * @param {DxModalOptions | undefined} context - контекст модального окна.
   */
  constructor(component: Type<any>, context: DxModalContext | undefined) {
    super(component, context, true);
    this.isClosable = false; // при true - плохая реакция на клик по тёмному background-у.
    this.isInverted = true;
    this.isBasic = false;
    this.transitionDuration = 100;
    this.size = <ModalSize> context.options.size;
  }
}
